// ------------------------------------
// General configs
// ------------------------------------

/**
 * Default server API url
 * @type {string}
 */
export const serverUrl = process.env.REACT_APP_SERVER_URL

/**
 * Uri of the server, where the API is set
 * @type {string}
 */
const apiUri = process.env.REACT_APP_APP_URI

/**
 * API url
 *
 * It's defined by the above settings,
 * so please refer to `serverUrl` and `apiUri` documentation
 *
 * @type {string}
 */
export const apiUrl = `${serverUrl}${apiUri}`

/**
 * EmailJS user ID
 * @type {string}
 */
export const emailJsUserId = process.env.REACT_APP_EMAILJS_USERID

/**
 * EmailJS Template ID
 * @type {string}
 */
export const emailJsTemplateId = process.env.REACT_APP_EMAILJS_TEMPLATEID

/**
 * EmailJS Service ID
 * @type {string}
 */
export const emailJsServiceId = process.env.REACT_APP_EMAILJS_SERVICEID



// WEBPACK FOOTER //
// ./src/utils/config.js